import { render, staticRenderFns } from "./experimentalReport.vue?vue&type=template&id=0bf780f0&scoped=true&"
import script from "./experimentalReport.vue?vue&type=script&lang=js&"
export * from "./experimentalReport.vue?vue&type=script&lang=js&"
import style0 from "./experimentalReport.vue?vue&type=style&index=0&id=0bf780f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf780f0",
  null
  
)

export default component.exports